import styled from '@emotion/styled/macro';

export const TabsContainer = styled.div`
    padding-top: 20px;
    padding-left: 16px;
`;
